import { useGlobalStore } from './useGlobalStore'
import { init } from './init'
init(useGlobalStore)
export { useGlobalStore }
